export interface ClocktowerPlazaAsset {
  readonly key: string;
  readonly path: string;
  readonly width: number;
  readonly height: number;
  readonly kind: 'image';
  readonly alpha: boolean;
  readonly required: true;
}

const ROOT = 'assets/number-kingdom/clocktower-plaza';
const image = (
  key: string,
  path: string,
  width: number,
  height: number,
  alpha: boolean,
): ClocktowerPlazaAsset => ({ key, path: `${ROOT}/${path}`, width, height, kind: 'image', alpha, required: true });

export const CLOCKTOWER_PLAZA_ASSETS = {
  dormant: image('clocktower-plaza-dormant', 'backgrounds/clocktower-plaza-dormant.png', 1280, 720, false),
  restored: image('clocktower-plaza-restored', 'backgrounds/clocktower-plaza-restored.png', 1280, 720, false),
  face: image('clocktower-plaza-face', 'interactives/royal-clock-face.png', 768, 768, true),
  hourHand: image('clocktower-plaza-hour-hand', 'interactives/hour-hand.png', 160, 384, true),
  minuteHand: image('clocktower-plaza-minute-hand', 'interactives/minute-hand.png', 160, 480, true),
} as const;

export const CLOCKTOWER_PLAZA_ASSET_LIST = Object.values(CLOCKTOWER_PLAZA_ASSETS);
export const CLOCKTOWER_PLAZA_PRODUCTION_READY = true;

export function preloadClocktowerPlazaAssets(scene: Phaser.Scene) {
  CLOCKTOWER_PLAZA_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path));
}

export function getMissingClocktowerPlazaAssets(textures: Phaser.Textures.TextureManager) {
  return CLOCKTOWER_PLAZA_ASSET_LIST.filter(asset => !textures.exists(asset.key));
}

export function canEnterClocktowerPlaza(textures: Phaser.Textures.TextureManager) {
  return CLOCKTOWER_PLAZA_PRODUCTION_READY
    && getMissingClocktowerPlazaAssets(textures).length === 0;
}
